/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * New uses of this type are discouraged because of difficulty describing its usage when embedded in APIs.
 * 1. Invalid usage help.  It is impossible to add specific help for individual usage.  In most embedded usages, there are particular
 * restrictions like, "must refer only to types A and B" or "UID not honored" or "name must be restricted".
 * Those cannot be well described when embedded.
 * 2. Inconsistent validation.  Because the usages are different, the validation rules are different by usage, which makes it hard for users to predict what will happen.
 * 3. We cannot easily change it.  Because this type is embedded in many locations, updates to this type
 * will affect numerous schemas.  Don't make new APIs embed an underspecified API type they do not control.
 * 
 * Instead of using this type, create a locally provided and used type that is well-focused on your reference.
 * For example, ServiceReferences for admission registration: https://github.com/kubernetes/api/blob/release-1.17/admissionregistration/v1/types.go#L533 .
 * +structType=atomic
 * @export
 * @interface V1LocalObjectReference
 */
export interface V1LocalObjectReference {
    /**
     * Name of the referent.
     * This field is effectively required, but due to backwards compatibility is
     * allowed to be empty. Instances of this type with an empty value here are
     * almost certainly wrong.
     * More info: https://kubernetes.io/docs/concepts/overview/working-with-objects/names/#names
     * +optional
     * +default=""
     * +kubebuilder:default=""
     * TODO: Drop `kubebuilder:default` when controller-gen doesn't need it https://github.com/kubernetes-sigs/kubebuilder/issues/3896.
     * @type {string}
     * @memberof V1LocalObjectReference
     */
    name?: string;
}

export function V1LocalObjectReferenceFromJSON(json: any): V1LocalObjectReference {
    return V1LocalObjectReferenceFromJSONTyped(json, false);
}

export function V1LocalObjectReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1LocalObjectReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function V1LocalObjectReferenceToJSON(value?: V1LocalObjectReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

